<style src="./ProductGallery.scss" lang="scss" scoped></style>
<script src="./ProductGallery.js"></script>

<template>
  <div
    v-if="currentVariant"
    class="pro-dec-big-img-slider product-big-img-style"
  >
    <div
      v-for="productImage in productImages"
      :key="productImage.url"
      class="easyzoom easyzoom--overlay"
      ref="easyzoom"
    >
      <a :href="productImage.url">
        <img
          :class="
            !quickview ? 'product-image' : 'quickview-img'
          "
          :src="productImage.url"
          alt=""
          data-test="product-image"
        />
      </a>
    </div>
  </div>
</template>
